import { render, staticRenderFns } from "./FreeHealthCheck.vue?vue&type=template&id=44662ad9"
import script from "./FreeHealthCheck.vue?vue&type=script&lang=js"
export * from "./FreeHealthCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports